import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=d64b2ba6&scoped=true&"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BookingConfirmation.vue?vue&type=style&index=0&id=d64b2ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64b2ba6",
  null
  
)

component.options.__file = "BookingConfirmation.vue"
export default component.exports